import { render } from "./CarLandscape.vue?vue&type=template&id=794e8ddf"
import script from "./CarLandscape.vue?vue&type=script&lang=js"
export * from "./CarLandscape.vue?vue&type=script&lang=js"

import exportComponent from "/__w/oscar/oscar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__